module.exports = __webpack_public_path__ + "img/west-indies-logo-icon.e97dcb1d.png";